import React from 'react';

const FORMATS = { call: 'Appel', video: 'Visio', meeting: 'Rencontre à Paris' };
const parisIso = (offset) => {
  const d = new Date(Date.now() + offset * 86400000);
  return d.toLocaleDateString('en-CA', { timeZone: 'Europe/Paris' });
};
const label = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

const DayColumn = ({ title, iso, items, testid }) => (
  <div data-testid={testid} style={{ flex: '1 1 300px' }}>
    <p className="meta-text" style={{ color: 'var(--gold-accent)', marginBottom: '4px' }}>{title}</p>
    <p className="body-small" style={{ color: 'var(--text-light)', marginBottom: '16px' }}>{label(iso)}</p>
    {items.length === 0 && <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>Aucun rendez-vous.</p>}
    {items.map((b) => (
      <div key={b.id} data-testid={`${testid}-item-${b.id}`} style={{ display: 'flex', gap: '16px', padding: '10px 0', borderBottom: '1px solid var(--border-light)' }}>
        <span className="heading-3" style={{ minWidth: '56px' }}>{b.time}</span>
        <div>
          <p className="body-regular">{b.full_name} · <span style={{ color: 'var(--text-secondary)' }}>{FORMATS[b.format] || ''}</span></p>
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
            <a href={`mailto:${b.email}`}>{b.email}</a>{b.phone ? ` · ${b.phone}` : ''}{b.location ? ` · ${b.location}` : ''}
          </p>
        </div>
      </div>
    ))}
  </div>
);

export const TodayPanel = ({ bookings }) => {
  if (!bookings) return null;
  const today = parisIso(0);
  const tomorrow = parisIso(1);
  const pick = (iso) => bookings.filter((b) => b.date === iso).sort((a, c) => a.time.localeCompare(c.time));
  return (
    <div data-testid="admin-today-panel" style={{ display: 'flex', gap: '48px', flexWrap: 'wrap', padding: '24px 0 32px', marginBottom: '32px', borderBottom: '1px solid var(--border-light)' }}>
      <DayColumn title="Aujourd'hui" iso={today} items={pick(today)} testid="admin-today" />
      <DayColumn title="Demain" iso={tomorrow} items={pick(tomorrow)} testid="admin-tomorrow" />
    </div>
  );
};
